import { FORM_DATA_KEY_FACTORY } from '@/api/getters';
import { completeStage, setFormMutation, updateStep } from '@/api/setters';
import { FormData, Stages, Steps } from '@/api/types';
import { formMutationDto } from '@/dto/formMutationDto';
import {
  getUserType,
  vehicleDamageDataLayer,
} from '@/helpers/addStageToDataLyer';

import { QueryClient } from '@tanstack/react-query';

interface AppLoaderVDProps {
  data: FormData;
  id: string;
  queryClient: QueryClient;
}

const appLoaderVD = async ({ data, id, queryClient }: AppLoaderVDProps) => {
  if (!data || !id) return;

  const userType = getUserType(data);

  !data.step && updateStep(id, Steps.START);
  !data.step && vehicleDamageDataLayer.startForm(userType);
  !data.step &&
    data.stage === Stages.STAGE_I &&
    vehicleDamageDataLayer.startStage(data.stage, userType);

  if (
    data.stage === Stages.STAGE_III_FINISHED &&
    data?.offer?.offer_rejected === false
  ) {
    await setFormMutation(id, {
      ...formMutationDto({
        form_data: data?.payload?.data ?? null,
        stepper: {
          step: data.offer.is_complementary ? 4 : 5,
          innerStep: data?.payload?.stepper?.innerStep ?? {},
        },
      }),
    });
    await completeStage(id, Stages.STAGE_III_FINISHED);
    await updateStep(id, Steps.TRANSFER_DETAILS);
    await queryClient.invalidateQueries({
      queryKey: FORM_DATA_KEY_FACTORY(id),
    });
  }

  if (data.stage === Stages.STAGE_V_FINISHED && data.attachments?.length) {
    await completeStage(id, Stages.STAGE_V_FINISHED);
    queryClient.invalidateQueries({
      queryKey: FORM_DATA_KEY_FACTORY(id),
    });
  }
};

export default appLoaderVD;
